export const GET_MONITORING_DATA = 'GET_MONITORING_DATA';
export const GET_MONITORING_LOCATIONS = 'GET_MONITORING_LOCATIONS';
export const SET_MONITORING_FILTERS = 'SET_MONITORING_FILTERS';
export const GET_MONITORING_PATH_SPEED = 'GET_MONITORING_PATH_SPEED';
export const GET_MONITORING_STOP_LOCATIONS = 'GET_MONITORING_STOP_LOCATIONS';
